import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import MainBannerImages from "./MainBannerImages";

function MainBannerImagesView() {
  const { device } = useParams();

  const defaultTab = useMemo(() => {
    if (device === "desktop") return "desktop";
    if (device === "mobile") return "mobile";
    return "all";
  }, [device]);

  return <MainBannerImages defaultTab={defaultTab} />;
}

export default MainBannerImagesView;
